import React from 'react'
import Startermenu from '../Allmenus/FirstMenu/Startermenu';
import Offer from '../Allmenus/FirstMenu/Offers'
import Bredcom from '../Bredcrumb/Main'
import Img from '../../assets/images/background/banner-image-2.jpg'

function Breakfast() {
  return (
    <>
      <Bredcom subtitle="Breakfast Menu" title="FRESH & AMAZING" Img={Img} />
      <Startermenu />
      <Offer />
    </>
  )
}

export default Breakfast